import { addGETParams } from '../../config'
import ax from '../api'

/*
 * setDocumentation - Set a documentation item on the server
 * @param {string} documentationId - The id of the documentation item
 * @param {object} full - The full object of the documentation item
 * @returns {object} The response from the server
 */
export const setDocumentation = async (documentationId, full) => {
	const _url = addGETParams(`/documentation/set.php`, {
		documentation_id: documentationId,
		...full
	})

	return await ax.post(_url)
}

/*
 * getDocumentationList - Retrieve a list of documentation items from the server
 * @param {object} params - Parameters to filter and paginate the documentation list
 * @returns {object} The response from the server containing the list of documentation
 */
export const getDocumentationList = async (params) => {
	const _url = addGETParams(`/documentation/lst.php`, params)

	return await ax.post(_url)
}

/*
 * getDocumentation - Retrieve a specific documentation item from the server
 * @param {string} documentation_id - The id of the documentation item to retrieve
 * @returns {object} The response from the server containing the documentation item
 */
export const getDocumentation = async (documentation_id) => {
	const _url = addGETParams(`/documentation/get.php`, {
		documentation_id
	})

	return await ax.post(_url)
}
